import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { TaxesDao } from '@app/dao/taxes/taxes.dao';
import * as _ from 'lodash';
import { combineLatest, Subject } from 'rxjs';
import { EaDeductionFormBuilder } from './ea-deduction-form.builder';

@Component({
    selector: 'ea-deduction-form',
    templateUrl: './ea-deduction-form.component.html',
    styleUrls: ['./ea-deduction-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaDeductionFormComponent),
        },
    ],
    standalone: false
})
export class EaDeductionFormComponent
  extends EaDeductionFormBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();
  fiscalType: any[];

  constructor(
    protected formConstructor: PrFormConstructor,
    private taxesDao: TaxesDao,
    private referenceDao: ReferenceDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    combineLatest([this.referenceDao.getFiscalType()]).subscribe(
      ([fiscalTypes]) => {
        this.fiscalType = _.filter(fiscalTypes, ['groupe', 'DEDUCTION']);
        if (!this.entity.id) {
          this.form.controls.type.setValue(
            this.fiscalType.find(
              type => type.type === this.form.controls.type.value,
            ),
          );
        }
      },
    );
  }

  get title() {
    return this.entity.id ? this.entity.label : "Ajout d'une déduction";
  }

  onSubmit() {
    //Fetch every form controls value
    let formDTOExtraction = _.merge(this.entity, this.extract());
    this.prFormService.loading();
    this.taxesDao
      .saveDeductionReduction('deduction', formDTOExtraction)
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          this.notificationService.success('La sauvegarde a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La sauvegarde a échoué');
        },
      );
  }
}
